module.exports = __webpack_public_path__ + "img/vehicle-warning.8c0d02d0.svg";